import { useNavigate } from "react-router-dom";
import { CardConnectionsPage as CardConnectionsPageView } from "@/components/CardConnectionsPage";

export function CardConnectionsPage() {
  const navigate = useNavigate();
  return (
    <CardConnectionsPageView
      onSelectExpense={(id) => navigate(`/expenses/${id}`)}
      onViewSpend={(cardId) => navigate(`/expenses?card=${cardId}`)}
    />
  );
}
